var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"beamer-club-assistant-page"},[_c('BeamerClubAgentModal',{on:{"close":_vm.handleClose},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }